module.exports = __webpack_public_path__ + "static/media/MrKingChan.2fe1a070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub2/MrKingChan.jpg
// module id = 210
// module chunks = 0